import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای مدیریت پالت‌ها (Lots)

تمامی پالت‌های فیزیکی موجود در سیستم با شماره منحصر‌به‌فرد در این صفحه مدیریت می‌شوند.

## ۱. لیست پالت‌ها
پالت‌ها (لات‌ها) با شماره ردیابی مشخص در این لیست قرار دارند و می‌توانید وضعیت آنها را (آزاد، در حال مصرف، تمام شده) مشاهده کنید.

## ۲. عملیات روی پالت
امکان چاپ لیبل، تغییر وضعیت، و مشاهده موجودی دقیق هر پالت در این قسمت فراهم است.

export default Layout;
